import { Injectable } from '@angular/core';
import { AbstractDeviceConnectivityModuleService } from '@iot-platform/data-access/devices';
import { DeviceConnectivityModule } from '@iot-platform/models/common';
import { Device } from '@iot-platform/models/i4b';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceConnectivityModuleService extends AbstractDeviceConnectivityModuleService<Device> {
  getConnectivityDetails(device: Device): Observable<DeviceConnectivityModule> {
    return this.httpClient.get<DeviceConnectivityModule>(
      `${this.environment.api.url}${this.environment.api.endpoints.devices}/${device.id}/connectivity-module`
    );
  }
}
